/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { IbanMaster } from "./IbanMaster";
import { IbanValidiPerPa } from "./IbanValidiPerPa";
import { InformativePaMaster } from "./InformativePaMaster";
import * as t from "io-ts";

// required attributes
const PaR = t.interface({});

// optional attributes
const PaO = t.partial({
  capDomicilioFiscale: t.string,

  cbill: t.string,

  comuneDomicilioFiscale: t.string,

  denominazioneDomicilioFiscale: t.string,

  description: t.string,

  enabled: t.boolean,

  fkIntQuadrature: t.Integer,

  idDominio: t.string,

  indirizzoDomicilioFiscale: t.string,

  objId: t.Integer,

  pagamentoPressoPsp: t.boolean,

  ragioneSociale: t.string,

  rendicontazioneFtp: t.boolean,

  rendicontazioneZip: t.boolean,

  siglaProvinciaDomicilioFiscale: t.string
});
// NOTE: fix-circular-generated-models: patched to break a circular
// import cycle detected among: InformativePaFasce, InformativePaDetail, InformativePaMaster, IbanValidiPerPa, IbanAttributeMaster, Iban, IbanMaster, Pa.
// This block is regenerated automatically by
// scripts/fix-circular-generated-models.js after every `gen-api-models` run
// - do not hand-edit `generated/` files, they are wiped on each generation.
export type Pa = t.TypeOf<typeof PaR> &
  t.TypeOf<typeof PaO> & {
  readonly "ibanMasters"?: ReadonlyArray<IbanMaster>;
  readonly "ibans"?: ReadonlyArray<IbanValidiPerPa>;
  readonly "informativePaMasters"?: ReadonlyArray<InformativePaMaster>;
  };

export const Pa: t.Type<Pa> = t.recursion("Pa", () =>
  t.intersection(
    [PaR, t.partial({ ...PaO.props, "ibanMasters": t.readonlyArray(IbanMaster, "array of IbanMaster"), "ibans": t.readonlyArray(IbanValidiPerPa, "array of IbanValidiPerPa"), "informativePaMasters": t.readonlyArray(
    InformativePaMaster,
    "array of InformativePaMaster"
  ) })],
    "Pa"
  ) as unknown as t.Type<Pa>
);
